import React, { useCallback } from "react";
import { ModuleTask, QuestModule as QuestModuleType } from "../../types";
import { CheckCircledIcon, LockClosedIcon } from "@radix-ui/react-icons";
import { Task } from "../Tasks";
import { useQuestContext } from "../../context/QuestContext";

export interface QuestModuleProps {
  data: QuestModuleType;
}

const QuestModule: React.FC<QuestModuleProps> = ({ data }: { data: any }) => {
  const {
    currentTaskId,
    currentModuleId,
    setCurrentTaskId,
    setCurrentModuleId,
    modulesCompleted,
    tasksList,
    tasksCompleted,
  } = useQuestContext();

  const isModuleComplete = !!modulesCompleted.find((m) => m.id === data?.id);
  const isActive = currentModuleId === data?.id;

  const onClick = useCallback(() => {
    if (isModuleComplete) {
      if (currentModuleId === data?.id) {
        setCurrentModuleId("");
        setCurrentTaskId("");
      } else {
        const [firstTask]: Array<any> = tasksList.filter(
          (t) => t.moduleId === data?.id,
        );
        setCurrentTaskId(firstTask?.data?.id);
        setCurrentModuleId(data?.id);
      }
    }
  }, [isModuleComplete, currentModuleId, data, tasksList]);

  const completedModuleTasks = tasksCompleted.filter(
    (taskId: string) => !!taskId.includes(data?.id),
  );

  return (
    <div className="bad-quest__module">
      <div className="bad-quest__module--content">
        <h4 className="bad-quest__module--title">{data.name}</h4>
        <p className="bad-quest__module--right-text">
          {" "}
          {completedModuleTasks.length}/{data?.tasks?.length} Steps
        </p>
      </div>
      {/*<div className="bad-quest__module--content">*/}
      {/*  <div className="bad-quest__module--content_right">*/}
      {/*    <div className="bad-quest__module--content_right_bar" />*/}
      {/*    <div className="bad-quest__module--content_right_info">*/}
      {/*      <h3*/}
      {/*        className={`bad-quest__module--content_right_info_title ${*/}
      {/*          isModuleComplete &&*/}
      {/*          "bad-quest__module--content_right_info_title_completed"*/}
      {/*        }`}*/}
      {/*        onClick={onClick}*/}
      {/*      >*/}
      {/*        {data.name}*/}
      {/*      </h3>*/}
      {/*      <p className="bad-quest__module--content_right_info_subtitle">*/}
      {/*        {data?.tasks?.length} {data?.tasks?.length > 1 ? "Tasks" : "Task"}*/}
      {/*      </p>*/}
      {/*    </div>*/}
      {/*  </div>*/}
      {/*  {isModuleComplete || isActive ? (*/}
      {/*    <CheckCircledIcon*/}
      {/*      className={`bad-quest_task__check_icon ${*/}
      {/*        isModuleComplete*/}
      {/*          ? "bad-quest_task__check_icon_completed"*/}
      {/*          : "bad-quest_task__check_icon_not_completed"*/}
      {/*      }`}*/}
      {/*    />*/}
      {/*  ) : (*/}
      {/*    <LockClosedIcon className="bad-quest_task__lock_icon" />*/}
      {/*  )}*/}
      {/*</div>*/}
      {data?.tasks.map((task, index) => (
        <Task
          key={index}
          data={task}
          moduleId={data?.id}
          isOpen={task.id === currentTaskId}
        />
      ))}
    </div>
  );
};

export { QuestModule };
